import React from 'react'
import noop from 'lib/noop'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import styled from 'styled-components'
import TextButton from 'components/Luxkit/Button/TextButton'
import { rem } from 'polished'

const FooterButtons = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: ${rem(8)};
`

const StyledModalContent = styled(ModalContent)`
  height: 100%;
`
interface Props {
  desktop?: boolean;
  isOpen: boolean;
  onClose?: () => void;
  onNoThanks?: () => void;
  onUpgrade?: () => void;
  children: React.ReactNode;
}

function PackageUpgradeModal({
  desktop = false,
  isOpen,
  onClose,
  onNoThanks,
  onUpgrade,
  children,
}: Props) {
  return (
    <ModalBase
        isOpen={isOpen}
        size={desktop ? 'large' : 'small'}
        onClose={onClose}
      >
      <ModalHeader
          title="Want to upgrade your package?"
          subtitle="Pay a little extra for a more luxurious stay."
          onCloseButtonClick={!desktop ? onClose : undefined}
        />
      <ModalBody>
        <StyledModalContent>
          {children}
        </StyledModalContent>
      </ModalBody>
      <ModalFooter
          isPrimaryActionHidden={!desktop}
          isSecondaryActionHidden={!desktop}
          primaryActionProps={{
            children: 'Upgrade',
            onClick: onUpgrade,
          }}
          secondaryActionProps={{
            children: 'No thanks',
            onClick: onNoThanks,
          }}
        >
        {!desktop && (
          <FooterButtons>
            <TextButton kind="tertiary" size="large" onClick={onNoThanks}>No thanks</TextButton>
            <TextButton kind="primary" size="large" onClick={onUpgrade}>Upgrade</TextButton>
          </FooterButtons>
        )}
      </ModalFooter>
    </ModalBase>
  )
}

PackageUpgradeModal.defaultProps = {
  onClose: noop,
  onNoThanks: noop,
  onUpgrade: noop,
}

export default PackageUpgradeModal
